<template>
	<main>
		<div class="border-divisor-up"></div>
		<div class="row">
			<inline-alert-component v-if="seenAlert" type="primary" message="Informações" />
		</div>

		<div class="row state-overview">
			<div class="col-lg-4 col-sm-7">
				<section class="card" style="margin-bottom: 0 !important;">
					<div class="icons gray">
						<i class="fas fa-sign-in-alt"></i>
					</div>
					<div class="titles">
						<h1 class="count">{{ totalLogin }}</h1>
						<p>Total de Logins</p>
					</div>
				</section>
			</div>
			<div class="col-lg-4 col-sm-7">
				<section class="card" style="margin-bottom: 0 !important;">
					<div class="icons gray">
						<i class="fas fa-clock"></i>
					</div>
					<div class="titles">
						<h1 class="count2">{{ avgTime }}</h1>
						<p>Tempo Médio de Duração</p>
					</div>
				</section>
			</div>
			<div class="col-lg-4 col-sm-7">
				<section class="card" style="margin-bottom: 0 !important;">
					<div class="icons gray">
						<i class="fas fa-clock"></i>
					</div>
					<div class="titles">
						<h1 class="count3">{{ totalTime }}</h1>
						<p>Tempo Total de Duração</p>
					</div>
				</section>
			</div>
		</div>

		<div class="border-divisor-down"></div>

		<div class="card logs">
			<table ref="durationLogin" class="table display table-hover table-striped nowrap" cellspacing="0" width="100%">
				<thead>
					<tr>
						<th class="text-center">Data</th>
						<th class="text-center">Operador</th>
						<th class="text-center">Ramal</th>
						<th class="text-center">Hora Inicial</th>
						<th class="text-center">Hora Final</th>
						<th class="text-center">Duração</th>
					</tr>
				</thead>
				<tbody>
				</tbody>
			</table>
		</div>
	</main>
</template>

<script>
	export default {
		name: "DurationLogin",
		data() {
			return {
				avgTime: "00:00:00",
				totalLogin: 0,
				totalTime: "00:00:00",
				seenAlert: true,
				dtDurationLogin: null,
			};
		},
		methods: {
			totalizer(response) {
				this.totalLogin = response.totalLogins;
				this.avgTime = response.avgTime;
				this.totalTime = response.totalTime;
			},
			// MONTA AS TABELAS DE LIGAÇÕES
			mountDt({ startDate, endDate }) {
				if (startDate && endDate) {
					this.seenAlert = true;
				} else {
					this.seenAlert = false;
				}

				this.dtDurationLogin = $(this.$refs.durationLogin).DataTable({
					destroy: true,
					order: [[4, "asc"]],
					ajax: {
						url: '/reports/renewTurnos',  // Atualize o URL da API
						data: () => {
							return {
								startDate: startDate,
								endDate: endDate,
							};
						},
						dataSrc: 'logs',
						dataType: 'json',
						type: 'get',
						error: function (response) {
							console.error(response);
						},
					},
					columns: [
						{ data: "date", className: "text-center" }, 
						{ data: "agent", className: "text-center" }, 
						{ data: "extension_line", className: "text-center" }, 
						{ data: "startTime", className: "text-center" }, 
						{ data: "endTime", className: "text-center" }, 
						{
							data: "duration",
							className: "text-center",
							render: function (data) {
								return data;
							},
						},
					],
					initComplete: (settings) => {
						this.seenAlert = false;
						this.totalizer(settings.json);
					},
				});
			},
			mountData() {
				this.mountDt(this.dates);
			},
		},
		computed: {
			dates() {
				return {
					startDate: this.$store.state.startDate,
					endDate: this.$store.state.endDate,
				};
			},
		},
		watch: {
			dates() {
				this.mountData();
			},
		},
		mounted() {
			this.mountData();
		},
	};
</script>


<style scoped>
	/* Estilo para os cards */
	.border-divisor-up {
		margin-top: 2rem;
		border: 0;
		border-top: 1px solid rgba(0, 0, 0, 0.1);
	}
	.border-divisor-down {
		margin-top: 2rem;
		margin-bottom: 2rem;
		border: 0;
		border-top: 1px solid rgba(0, 0, 0, 0.1);
	}
	.state-overview .card {
		display: block;
		margin-bottom: 2rem;
		margin-top: 2rem;
		border: none;
	}
	.state-overview .gray {
		background: #999999;
	}
	.state-overview .icons {
		width: 70px;
		height: 70px;
		border-radius: 4px 0 0 4px;
		padding: 21px 21px;
	}
	.state-overview .icons i {
		color: #fff;
		font-size: 27px;
	}
	.state-overview .icons,
	.state-overview .titles {
		display: inline-block;
	}
	.state-overview .titles {
		padding-top: 3px;
		text-align: right;
		padding-right: 4px;
	}
	.state-overview .titles {
		float: right;
	}
	.state-overview .titles h1,
	.state-overview .titles p {
		margin: 9px 4px;
		padding: 0;
		color: #7b7c80;
		font-size: 0.96rem;
		font-weight: 300;
	}
</style>
